import styled from 'styled-components';
import { Tab as RTTab, TabProps } from 'react-tabs';

interface Props extends TabProps {
  isMobile?: boolean;
}

export const Tab = styled(RTTab)<Props>(({ theme, selected, isMobile }) => ({
  display: 'inline-block',
  position: 'relative',
  listStyle: 'none',
  cursor: 'pointer',
  marginLeft: isMobile ? 6 : 12,
  marginRight: isMobile ? 6 : 12,
  marginBottom: -1,
  borderTopLeftRadius: 4,
  borderTopRightRadius: 4,
  fontFamily: theme.fontFamily,
  fontWeight: theme.fontWeights[500],
  fontSize: theme.fontSizes.body,
  padding: isMobile ? '10px 4px' : '10px 8px',
  color: selected ? theme.colors.primary['500'] : theme.colors.neutral['500'],
  background: 'transparent',
  boxShadow: `inset 0px -2px 0px 0px ${selected ? theme.colors.primary['500'] : 'rgba(0,0,0,0)'}`,
  transition: `color ${theme.transitions.normal}, box-shadow ${theme.transitions.normal}`,

  '&[data-focus-visible-added]:not(.disabled):focus': {
    outline: 'none',
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
    zIndex: 1,
  },

  '&:hover': {
    color: selected ? theme.colors.primary['500'] : theme.colors.neutral['700'],

    boxShadow: `inset 0px -2px 0px 0px ${
      selected ? theme.colors.primary['500'] : theme.colors.neutral['300']
    }`,
  },

  '&:first-of-type': {
    marginLeft: 0,
  },

  '&:last-of-type': {
    marginRight: 0,
  },
}));
